<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import city from "../../../helpers/list/city";
import type_residential_unit from "../../../helpers/list/type_residential_unit";

export default {
  components: {},
  props: {},

  data() {
    return {
      city_id: "1",
      type_residential_unit_id: "1",
      land_area: "",

      //lists
      list_city: city,
      list_type_residential_unit: type_residential_unit,
    };
  },
  validations: {
    city_id: { required },
    type_residential_unit_id: { required },
    land_area: { required, minValue: minValue(50), maxValue: maxValue(9000) },
    form: ["city_id", "type_residential_unit_id", "land_area"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- شهيد -->
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">حدد مواصفات الوحدة السكنية</h5></div>

      <b-form-group class="col-md-4 mb-3" label=" المحافظة  : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in list_city" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>

      <b-form-group
        class="col-md-4 mb-3"
        label=" نوع ملكية الارض : "
        label-for="type_residential_unit_id"
      >
        <select
          class="form-control"
          id="type_residential_unit_id"
          v-model="type_residential_unit_id"
          :class="{ 'is-invalid': $v.type_residential_unit_id.$error }"
        >
          <option value="">اختر نوع ملكية الارض</option>
          <option
            v-for="type_residential_unit in list_type_residential_unit"
            :value="type_residential_unit.id"
            :key="type_residential_unit.id"
          >
            {{ type_residential_unit.name }}
          </option>
        </select>
        <div v-if="$v.type_residential_unit_id.$error" class="invalid-feedback">
          <span v-if="!$v.type_residential_unit_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-4 mb-3" label=" مساحة الارض : " label-for="land_area">
        <b-form-input
          id="land_area"
          type="text"
          placeholder="ادخل مساحة الارض"
          v-model="land_area"
          :class="{ 'is-invalid': $v.land_area.$error }"
        ></b-form-input>
        <div v-if="$v.land_area.$error" class="invalid-feedback">
          <span v-if="!$v.land_area.required">هذا الحقل الزامي</span>
          <span v-if="!$v.land_area.minValue"
            >يجب أن تكون مساحة الارض 50 م على الأقل</span
          >
          <span v-if="!$v.land_area.maxValue"
            >يجب أن تكون مساحة الارض 9000 م على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
